import { CoachRequestDetail } from '../../shared/models/request-coach-detail.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RequestCoachService {
  private baseURL = environment.baseURL;
  constructor(private http: HttpClient) {}

  createCoachDetail(detail: CoachRequestDetail) {
    return this.http.post<CoachRequestDetail>(
      `${this.baseURL}/coaches-request`,
      detail
    );
  }

  getCoachDetail(requestID: number) {
    return this.http.get<CoachRequestDetail>(
      `${this.baseURL}/coaches-request/${requestID}`
    );
  }

  updateCoachDetail(requestID: number, detail: CoachRequestDetail) {
    return this.http.put<CoachRequestDetail>(
      `${this.baseURL}/coaches-request/${requestID}`,
      detail
    );
  }

  deleteCoachDetail(requestID: number) {
    return this.http.delete<CoachRequestDetail>(
      `${this.baseURL}/coaches-request/${requestID}`
    );
  }
}
